import React from "react";
import { Tooltip, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { AiIndicatorIcon } from "../../icons/AiIndicatorIcon";

interface AiIndicatorProps {
	mode: "icon-only" | "icon-with-text";
	className?: string;
	style?: React.CSSProperties;
}

const AiIndicator = ({ mode, className, style }: AiIndicatorProps) => {
	const { t } = useTranslation();

	if (mode === "icon-only") {
		return (
			<Tooltip title={t("AiIndicator.Tooltip")}>
				<span className={className} style={{ display: "inline-flex", alignItems: "center", ...style }}>
					<AiIndicatorIcon />
				</span>
			</Tooltip>
		);
	}

	return (
		<span className={className} style={{ display: "inline-flex", alignItems: "center", gap: 4, ...style }}>
			<Typography variant="body2" component="span">
				{t("AiIndicator.Label")}
			</Typography>
			<AiIndicatorIcon />
		</span>
	);
};

export default AiIndicator;
